import { Link } from "react-router";

import { UserWorkspaceScope } from "../../components/UserWorkspaceScope.js";
import {
	membershipsForUserBilling,
	membershipsForUserUsers,
} from "../../lib/user-dashboard.js";
import { useSession } from "../../lib/session.js";
import { TeamSection } from "../settings/TeamSection.js";
import { Billing } from "../Billing.js";
import { WorkspacesPage } from "../shell/WorkspacePages.js";

export function UserWorkspacesPage() {
	return <WorkspacesPage audience="user" />;
}

export function PlatformWorkspacePage() {
	return <WorkspacesPage audience="platform" />;
}

export function UserBillingPage() {
	const session = useSession();
	if (!session.data) return <p className="empty">Loading billing.</p>;
	const scoped = membershipsForUserBilling(session.data.memberships);
	if (scoped.length === 0) {
		return <UserBillingHint />;
	}
	return (
		<UserWorkspaceScope
			memberships={scoped}
			emptyTitle="No billing access"
			emptyDetail="Billing is available to workspace owners and billing contacts."
		>
			<Billing />
		</UserWorkspaceScope>
	);
}

export function UserUsersPage() {
	const session = useSession();
	if (!session.data) return <p className="empty">Loading users.</p>;
	const scoped = membershipsForUserUsers(session.data.memberships);
	return (
		<UserWorkspaceScope
			memberships={scoped}
			emptyTitle="No user management access"
			emptyDetail="Only workspace owners and administrators can view and manage people here. Open a workspace you administer, or ask an owner to adjust your role."
		>
			<TeamSection session={session.data} />
		</UserWorkspaceScope>
	);
}

export function UserBillingHint() {
	return (
		<div className="card">
			<h2>Billing lives with your workspace</h2>
			<p className="sub">
				Storage plans and invoices are tied to a workspace. Open one you own or administer to manage billing.
			</p>
			<p className="stack">
				<Link className="btn" to="/user/workspaces">
					Your workspaces
				</Link>
			</p>
		</div>
	);
}
